import { errorHandler } from '../../../util/error.service'
import * as routes from '../../routes/registration.routes'
import { authHttp } from '../http'

export async function saveMotivoAtraso(motivo, userId) {
  try {
    const response = await authHttp().post(routes.urlSaveMotivoAtraso(userId), motivo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateMotivoAtraso(motivo, userId) {
  try {
    const response = await authHttp().put(routes.urlUpdateMotivoAtraso(userId), motivo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getMotivoAtraso(user_id, tp_id, type = 'all') {
  try {
    const response = await authHttp().get(routes.urlGetMotivoAtraso(user_id, tp_id, type))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteMotivoAtraso(motivoId) {
  try {
    const response = await authHttp().delete(routes.urlDeleteMotivoAtraso(motivoId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
